import register from '../../../../global/js/registry';
export default register('m-filter-accordion', () => import(/* webpackMode: "lazy" */ './m-filter-accordion.controller'));
